import React from "react";
import { useDispatch } from "react-redux";
import { groupBy } from "lodash";

import { Icon, noop } from "rhombus-react";

import { openModal } from "reducers/Modal";
import { MODAL_TYPES } from "utils/constants";

export function organizeSocialErrors({ status = "", data = {} }){
	let {
			request: { filename = "" } = {},
			response: { errors = []} = {},
		} = data
		, errorsToGroup = {}
	;

	if(!/failed/gi.test(status)){ return; }

	// Websocket errors should be sorted, this is a failsafe block.
	if(errors && errors.length){
		errorsToGroup = errors.filter(err => err.sheet) // removes errors not assoc with a social
			.sort((erra, errb) => erra.line - errb.line) // sort each group by line/row#
			.map((each, idx)=> { //return deconstructed object and key to be used for mapping into JSX
				return {
					...each,
					key:`${each.sheet}-error-${idx}`,
			 	};
			});
	}

	return {
		filename,
		errorObj:groupBy(errorsToGroup, error => error.sheet),
	};
}

export default function SocialImportSocketError(props){
	let dispatch = useDispatch()
		, {
			clearMessage,
			timestamp,
			prettyTime,
			data = {},
		} = props
		, libraryName = data?.creativeLibrary?.name || "Library"
		, sheet = data?.request?.filename || ""
		;

	function viewErrors(e){
		e.preventDefault();
		dispatch(openModal(MODAL_TYPES.socialSocketErrors, organizeSocialErrors(props)));
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${props.iconInfo.icon}`} title={props.iconInfo.title} />
		, <div key="body" className="message-body">
			<div className="socket-error-message">
				<span>Error importing social creatives sheet:</span>
				<span title={sheet} className="text-overflow sheet-name">{sheet}</span>
				<a href="#" onClick={viewErrors}>View Errors</a>
			</div>
		</div>
		, <Icon key="clear" name="clear" iconStyle="fal" className="clear-message" title="Clear Message" onClick={clearMessage} />
		, <b key="empty" />
		, <span key="footer" className="message-footer name-overflow" title={libraryName}>{libraryName}</span>
		, <time key="time" className="message-time" dateTime={timestamp}>{prettyTime}</time>
	];
}

SocialImportSocketError.displayName = "SocialImportSocketError";
SocialImportSocketError.defaultProps = {
	clearMessage:noop,
	prettyTime:"",
	timestamp:"",
	data:{},
	iconInfo:{},
};
